export default __webpack_public_path__ + "static/media/beach_4.63ac1061.jpg";